<template>
  <Tag severity="danger">
    {{ t('issue') }}
  </Tag>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
